import { useState } from 'react';
import img1 from '../Components/Images/antennas/x1.png'
import img2 from '../Components/Images/antennas/x2.png'
import img3 from '../Components/Images/antennas/x3.png'
import img4 from '../Components/Images/antennas/x4.png'

import './zartecbutton.css'
import './AM_antenna.css'
export default function Xperience_antenna() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  
  // Sample product data - replace with your actual products
  const products = [
    {
      id: 1,
      name: "XSENSE AM45 Dawn",
      category: "Premium",
      image: img1,
      description: "The XSENSE AM45 combines AM based 58 kHz article surveillance with integrated visitor counting. Bidirectional sensors, count the number of visitors entering and leaving the store.",
      details: [
        "Remote service enabled",
        "Transparent panels",
        "Compatible with analytics",
        "Jammer detection"
      ],
      rating :5
    },
    {
      id: 2,
      name: "XSENSE AM45 Night",
      category: "High-End",
      image: img2,
      description: "It is designed with maximum transparency, minimizing entrance obstruction and offers maximum detection of hard tags and disposable tags in challenging store environments.",
      details: [
        "Integrated visitor count",
        "Compatible with analytics",
        "Optional advertising",
        "Integrated doorbell"
      ],
      rating :5
    },
    {
      id: 3,
      name: "XSENSE AM45 Sunset",
      category: "High-End",
      image: img3,
      description: "It is designed with maximum transparency, minimizing entrance obstruction and offers maximum detection of hard tags and disposable tags in challenging store environments.",
      details: [
        "Optional advertising",
        "Alarm lights: Multicolor",
        "Integrated doorbell",
        "Jammer detection"
      ],
      rating :4
    }
    
      
      
  ];

  const handleProductClick = (productId) => {
    setSelectedProduct(productId === selectedProduct ? null : productId);
  };

  return (
    <div className="container ">
      <div className="row product-grid ">
        {products.map(product => (
          <div key={product.id} className="">
            {/* col-md-3 mb-4 */}
            <div 
              className={`product-card ${selectedProduct === product.id ? 'selected' : ''}`}
              onClick={() => handleProductClick(product.id)}
            >
                {/* card content */}
            
            <div className="card-content" onClick={() => handleProductClick(product.id)}>  
              {/* Category Badge */}
              <div className="category-badge">{product.category}</div>
              
              {/* Product Name */}
              <h3 className="product-name">{product.name}</h3>
              
              {/* Product Image */}
              <div className="product-image-container">
                <img src={product.image} alt={product.name} className="product-image" loading="lazy"  />
              </div>
              
              {/* Product Description */}
              <div className="product-description">
                <p>{product.description}</p>
              </div>
              
              {/* Product Details */}
              <div className="product-details">
                <h5>Highlights</h5>
                <ul>
                  {product.details.map((detail, index) => (
                    <li key={index}>
                      <span className="detail-bullet">•</span> {detail}
                    </li>
                  ))}
                </ul>
              </div>
              <div className='text-center'>

                            {[...Array(5)].map((_, index) => (
                <span key={index} style={{ color: index < product.rating ? '#006672' : '#ccc', fontSize: '20px' }}>
                    ★
                </span>
                ))} 
                </div>   
              </div>
              
              {/* Action Button */}
             
              
              <div className='text-center'>
                <button className='btn zartec-btn zartec-btn-primary zartec-btn-small'>Get Product</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {/* CSS Styling */}
                <style jsx>{`

            .product-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 15px;
            }

            `}</style>
    </div>
  );
}

